export const uniq = (array = []) => {
  return [...new Set(array)];
};
